'use strict';

export class SeoText {
	static toggleState (element) {
		if (element.classList.contains('opened'))
			element.classList.remove('opened');
		else element.classList.add('opened');
	}
}